import { OrderItemStatus, OrderShipmentStatus, OrderShippingMethod } from '@codezo/graphql';

/** Exhaustive on purpose — a status added to the enum fails the build here, not silently. */
export const ORDER_ITEM_STATUS_LABEL: Record<OrderItemStatus, string> = {
	[OrderItemStatus.Pending]: 'Waiting to start',
	[OrderItemStatus.InProduction]: 'In production',
	[OrderItemStatus.ProductionCompleted]: 'Production finished',
	[OrderItemStatus.PartiallyShipped]: 'Partly shipped',
	[OrderItemStatus.Shipped]: 'Shipped',
	[OrderItemStatus.Delivered]: 'Delivered',
	[OrderItemStatus.Cancelled]: 'Cancelled',
};

export const SHIPMENT_STATUS_LABEL: Record<OrderShipmentStatus, string> = {
	[OrderShipmentStatus.Pending]: 'Not shipped yet',
	[OrderShipmentStatus.Shipped]: 'Shipped',
	[OrderShipmentStatus.Delivered]: 'Delivered',
	[OrderShipmentStatus.Cancelled]: 'Cancelled',
};

export const SHIPPING_METHOD_LABEL: Record<OrderShippingMethod, string> = {
	[OrderShippingMethod.Standard]: 'Standard',
	[OrderShippingMethod.Express]: 'Express',
};
